import OrbImageSlider from "./orb-image-slider";

export default OrbImageSlider;